<app-compliance-nav [activeMenuItem]="'reorders'"></app-compliance-nav>

<mat-card>


  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">
      <div>
        <!--<div fxLayout="row wrap" fxLayoutGap="8px" *ngIf="table" fxLayoutAlign="end center">

          <mat-form-field class="brand-filter-field"  *ngIf="!currentUserIsPartner()">
            <mat-select placeholder="Brand filters" [(ngModel)]="table.filters.companiesFilter" multiple>
              <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel"
                         [(ngModel)]="table.filters.startFilterDate"></app-date-edit>
          <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel"
                         [(ngModel)]="table.filters.endFilterDate"></app-date-edit>

          <mat-form-field class="search-field">
            <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                   [(ngModel)]="table.filters.str">
          </mat-form-field>
          <button #searchButton mat-icon-button (click)="onSearch()"
                  [disabled]="startDateFilter.invalid || endDateFilter.invalid">
            <mat-icon>search</mat-icon>
          </button>
          <button mat-icon-button (click)="table.clearFilter()">
            <mat-icon>clear</mat-icon>
          </button>

        </div>-->
      </div>
    </div>

  </div>


  <app-mat-table-generator #table
                           tableName="reordersQueuedTable"
                           [useEmbededFilter]="true"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="false"
                           [deleteEnabled]="false"
                           [multiselectEnabled]="false"
                           [rowClassCallback]="getRowClass"
                           [viewLink]="getCustomerOverviewLink"
                           [customActions]="reorderCustomActions"
  >
  </app-mat-table-generator>

</mat-card>


